// extracted by mini-css-extract-plugin
export default {"taxSummaryGrid":"customScreen_taxSummaryGrid__Tsd9g","actionsWrapper":"customScreen_actionsWrapper__WA2pV","suppressZerosCheckbox":"customScreen_suppressZerosCheckbox__vHzNL"};